module.exports = __webpack_public_path__ + "img/etc.fc290deb.svg";